import { useEffect, useState } from 'react';

/**
 * Remembers which link was just tapped so it can stay dimmed while the next page loads (the
 * links do full page loads, so nothing else shows that the tap landed). Cleared when the back
 * button restores this page from bfcache, which would otherwise bring it back still dimmed.
 */
export default function usePendingNavigation<T = true>() {
  const [pending, setPending] = useState<T | null>(null);

  useEffect(() => {
    const reset = (e: PageTransitionEvent) => e.persisted && setPending(null);
    window.addEventListener('pageshow', reset);
    return () => window.removeEventListener('pageshow', reset);
  }, []);

  return [pending, setPending] as const;
}
